import React from 'react'
import { PlayerIdentity, entryUser } from 'components/ReviewAudit/PublicRatings'
import { childNumber } from 'pages/Tenis10Claims/claimsLabels'

const fullName = person => [person?.firstName, person?.lastName].filter(Boolean).join(' ')
// PRD 16 LR11b (register E39 (1)): a Tenis10 child (profileId) is offered by its name and its parent — the parent's userId finds it
// in a search —, never with the parent's level, place or plan.
// RELEASE-TENIS10 § 11 P78: its own number after its name, where an adult's sits.
export const participantDescription = player => player.profileId
  ? `${fullName(player) || 'Child'}${childNumber(player) != null ? ` #${childNumber(player)}` : ''} · parent ${fullName(player.contact) || 'Account'} #${player.contact?.userId ?? player.userId}`
  : `${fullName(player)} id: ${player.userId} Single: ${player.gameLevel?.singles ?? player.gameLevelSingle ?? '—'} Double: ${player.gameLevel?.doubles ?? player.gameLevelDouble ?? '—'} ${player.location?.name || ''} account type: ${player.membership?.plan ?? '—'}`

// Keep selector values and search labels untouched. Options contain no links or
// buttons, so mouse and keyboard selection still belong to react-select.
export default function ParticipantOption(option) {
  if (option.data) return <PlayerIdentity player={option.data} to={null} interactive={false}>{option.label}</PlayerIdentity>
  const entry = option.value
  if (!entry?.user || entry.user.type === 'BYE') return option.label
  return <div>{[entryUser(entry), entry.partner].filter(Boolean).map((player, index) => <div key={player.userId || index}>
    <PlayerIdentity player={player} to={null} interactive={false}>
      {participantDescription(player)}
    </PlayerIdentity>
  </div>)}</div>
}
